import uniqueId from 'lodash/uniqueId';

import type {
    GetQueuedEmail_queuedEmail as QueuedEmail,
    GetEmailSequenceTemplate_emailSequenceTemplate,
    EmailSequenceTemplateTemplate,
} from 'nutshell-graphql-types';

export const PLACEHOLDER_ID = 'new-emailSequenceTemplate';

export function createSequenceTemplate(
    queuedEmail?: QueuedEmail | null
): GetEmailSequenceTemplate_emailSequenceTemplate {
    return {
        __typename: 'EmailSequenceTemplate',
        id: PLACEHOLDER_ID,
        name: 'Create an email template',
        isShared: true,
        group: null,
        isImmutable: false,
        isArchived: false,
        emailAutomation: null,
        creatorUser: {
            __typename: 'User',
            id: '',
            name: '',
            isEnabled: true,
        },
        lastSentTime: null,
        deletedTime: null,
        canEdit: true,
        parent: null,
        children: {__typename: 'EmailSequenceTemplatesConnection', totalCount: 0, edges: []},
        userChildSequenceTemplate: null,
        emailSequenceTemplateMessages: [
            {
                __typename: 'EmailSequenceTemplateMessage',
                id: uniqueId(),
                position: 1,
                sendDelay: {
                    __typename: 'EmailSequenceEmailTemplateSendDelay',
                    delayTimespan: 0,
                },
                sendAsReply: false,
                useSignature: true,
                emailTemplate: {
                    __typename: 'EmailTemplate',
                    id: uniqueId(),
                    subject: queuedEmail ? queuedEmail.subject : '',
                    plaintextBody: queuedEmail ? queuedEmail.bodyText : '',
                    body: queuedEmail ? queuedEmail.bodyHtml : '',
                    sentCount: 0,
                    clickCount: 0,
                    openedCount: 0,
                },
            },
        ],
    };
}

export function createNormalizedSequenceTemplate(
    queuedEmail?: QueuedEmail | null
): EmailSequenceTemplateTemplate {
    return {
        __typename: 'EmailSequenceTemplate',
        id: PLACEHOLDER_ID,
        name: 'Create an email template',
        isShared: true,
        group: null,
        isImmutable: false,
        isArchived: false,
        emailAutomation: null,
        creatorUser: {
            __typename: 'User',
            id: '',
            name: '',
            isEnabled: true,
        },
        parent: null,
        lastSentTime: null,
        deletedTime: null,
        canEdit: true,
        // @ts-expect-error
        children: {__typename: 'EmailSequenceTemplatesConnection', totalCount: 0, edges: []},
        userChildSequenceTemplate: null,
        emailSequenceTemplateMessages: [
            {
                __typename: 'EmailSequenceTemplateMessage',
                id: uniqueId(),
                position: 1,
                sendDelay: {
                    __typename: 'EmailSequenceEmailTemplateSendDelay',
                    delayTimespan: 0,
                },
                sendAsReply: false,
                useSignature: true,
                emailTemplate: {
                    __typename: 'EmailTemplate',
                    id: uniqueId(),
                    subject: queuedEmail ? queuedEmail.subject : '',
                    plaintextBody: queuedEmail ? queuedEmail.bodyText : '',
                    body: queuedEmail ? queuedEmail.bodyHtml : '',
                    sentCount: 0,
                    clickCount: 0,
                    openedCount: 0,
                },
            },
        ],
    };
}
